module.exports = __webpack_public_path__ + "img/ranks_img.a15f04d1.png";